import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Header from './header';
import Footer from './footer';
import { jsonp } from '@ifeng/ui_base';
import HonorItem from './honorItem';

const navData = {
    nav: [
        { title: '凤凰新媒体介绍', url: '//www.ifeng.com/corp/about/intro/' },
        { title: '投资者关系 Investor Relations', url: '//ir.ifeng.com/' },
        { title: '广告服务', url: '//biz.ifeng.com/' },
        { title: '诚征英才', url: '//career.ifeng.com/' },
        { title: '保护隐私权', url: '//www.ifeng.com/corp/privacy/' },
        { title: '免责条款', url: '//www.ifeng.com/corp/exemption/' },
        { title: '意见反馈', url: '//www.ifeng.com/corp/feedback/' },
        { title: '凤凰卫视介绍', url: '//phtv.ifeng.com/intro/' },
    ],
    content: {
        text0: '凤凰新媒体',
        text1: '版权所有',
        text2: 'Copyright © 2019 Phoenix New Media Limited All Rights Reserved.',
    },
};

const ths = [
    { en: 'Fri', cn: '23', date: '07-23' },
    { en: 'Sat', cn: '24', date: '07-24' },
    { en: 'Sun', cn: '25', date: '07-25' },
    { en: 'Mon', cn: '26', date: '07-26' },
    { en: 'Tue', cn: '27', date: '07-27' },
    { en: 'Wed', cn: '28', date: '07-28' },
    { en: 'Thu', cn: '29', date: '07-29' },
    { en: 'Fri', cn: '30', date: '07-30' },
    { en: 'Sat', cn: '31', date: '07-31' },
    { en: 'Sun', cn: '1', date: '08-01' },
    { en: 'Mon', cn: '2', date: '08-02' },
    { en: 'Tue', cn: '3', date: '08-03' },
    { en: 'Wed', cn: '4', date: '08-04' },
    { en: 'Thu', cn: '5', date: '08-05' },
    { en: 'Fri', cn: '6', date: '08-06' },
    { en: 'Sat', cn: '7', date: '08-07' },
    { en: 'Sun', cn: '8', date: '08-08' },
];

class Layout extends React.PureComponent {
    state = {
        honorMap: {},
        currentIndex: 0,
        currentDate: '07-23',
        todayIndex: -1,
    };

    componentDidMount() {
        jsonp('https://shankapi.ifeng.com/feedflow/coopdoc/doc_6d64e10f37a464947a19b81506be720a/info/cb', {
            jsonp: 'callback',
            jsonpCallback: 'cb',
            cache: false,
        }).then(res => {
            if (res.code === 0) {
                this.setState({
                    honorMap: res.data,
                });
            }
        });
        const date = new Date();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const today = `${month.toString().length === 1 ? `0${month}` : month}-${
            day.toString().length === 1 ? `0${day}` : day
        }`;
        // const today = '08-01';
        const index = ths.findIndex(t => t.date === today);

        this.setState({
            todayIndex: index,
            currentDate: index === -1 ? '07-23' : today,
            currentIndex: index === -1 ? 0 : index,
        });
    }

    changeCurrentIndex = e => {
        const { index, date } = e.currentTarget.dataset;
        const { todayIndex } = this.state;

        if (index <= todayIndex) {
            this.setState({
                currentIndex: +index,
                currentDate: date,
            });
        }
    };

    render() {
        const { honorMap, currentIndex, currentDate, todayIndex } = this.state;

        return (
            <div>
                <div style={{ backgroundColor: '#ffffff' }}>
                    <div className={styles.layout}>
                        <Header />
                    </div>
                </div>
                <div className={styles.banner}>
                    <img
                        src="https://x0.ifengimg.com/ucms/2021_30/B1FA541260DB0DF5E6B48EED95FE1C68410DD96D_size346_w2560_h814.png"
                        alt="中国骄傲"
                    />
                </div>
                <div className={styles.layout}>
                    <div className={styles.main}>
                        <div className={styles.table_wp}>
                            <table className={styles.table}>
                                <tbody>
                                    <tr>
                                        <td colSpan={19} className={styles.tips}>
                                            <div>所有显示时间均以北京时间为准</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colSpan={2} className={styles.type}>
                                            <div className={styles.en}>Date</div>
                                            <div className={styles.cn}>日期</div>
                                        </th>
                                        {ths.map((th, index) => (
                                            <th
                                                key={index}
                                                className={`${index === currentIndex && styles.current} ${index >
                                                    todayIndex && styles.disabled}`}
                                                data-index={index}
                                                data-date={th.date}
                                                onMouseEnter={this.changeCurrentIndex}>
                                                <div className={styles.en}>{th.en}</div>
                                                <div className={styles.cn}>{th.cn}</div>
                                            </th>
                                        ))}
                                    </tr>
                                    <tr className={styles.triangle}>
                                        <td colSpan={2} />
                                        {ths.map((th, index) => {
                                            return (
                                                <td
                                                    className={index === currentIndex && styles.current}
                                                    key={`tra${index}`}
                                                />
                                            );
                                        })}
                                    </tr>
                                    <tr className={styles.lead}>
                                        <td colSpan={2}>导语</td>
                                        <td colSpan={17}>
                                            <div>
                                                {honorMap[currentDate] && honorMap[currentDate].lead
                                                    ? honorMap[currentDate] && honorMap[currentDate].lead
                                                    : '当日暂无获得奖牌，中国代表队加油~'}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            {honorMap[currentDate] &&
                                honorMap[currentDate].gold.length > 0 && (
                                    <div>
                                        <div className={`${styles.partTitle} ${styles.gold}`}>
                                            <img
                                                src="https://x0.ifengimg.com/ucms/2021_29/D1D89B62C10CCA416478EDF7D1EB30E3AFDD0837_size17_w588_h43.png"
                                                alt="金牌"
                                            />
                                        </div>
                                        <div className={styles.part}>
                                            {honorMap[currentDate].gold.map((item, index) => {
                                                const { img, rank, url, title, name } = item;

                                                return (
                                                    <div className={styles.partItem} key={`gold${index}`}>
                                                        <HonorItem
                                                            isGold={true}
                                                            img={img}
                                                            rank={rank}
                                                            url={url}
                                                            title={title}
                                                            name={name}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            {honorMap[currentDate] &&
                                honorMap[currentDate].silver.length > 0 && (
                                    <div>
                                        <div className={styles.partTitle}>
                                            <img
                                                src="https://x0.ifengimg.com/ucms/2021_29/F6F854C989F67CA298E134B32458780E673FC7A0_size17_w588_h43.png"
                                                alt="银牌"
                                            />
                                        </div>
                                        <div className={styles.part}>
                                            {honorMap[currentDate].silver.map((item, index) => {
                                                const { img, rank, url, title, name } = item;

                                                return (
                                                    <div className={styles.partItem} key={`silver${index}`}>
                                                        <HonorItem
                                                            img={img}
                                                            rank={rank}
                                                            url={url}
                                                            title={title}
                                                            name={name}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            {honorMap[currentDate] &&
                                honorMap[currentDate].copper.length > 0 && (
                                    <div>
                                        <div className={styles.partTitle}>
                                            <img
                                                src="https://x0.ifengimg.com/ucms/2021_29/2FEAD171F5D4FB0BA7A2688AFF0C8D901C6EB8E6_size17_w588_h43.png"
                                                alt="铜牌"
                                            />
                                        </div>
                                        <div className={styles.part}>
                                            {honorMap[currentDate].copper.map((item, index) => {
                                                const { img, rank, url, title, name } = item;

                                                return (
                                                    <div className={styles.partItem} key={`copper${index}`}>
                                                        <HonorItem
                                                            img={img}
                                                            rank={rank}
                                                            url={url}
                                                            title={title}
                                                            name={name}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            {honorMap[currentDate] &&
                                honorMap[currentDate].breakthrough.length > 0 && (
                                    <div>
                                        <div className={styles.partTitle}>
                                            <img
                                                src="https://x0.ifengimg.com/ucms/2021_29/E837342DF50FF14DF71DE90402ADBC4D75387EB2_size16_w588_h43.png"
                                                alt="突破"
                                            />
                                        </div>
                                        <div className={styles.part}>
                                            {honorMap[currentDate].breakthrough.map((item, index) => {
                                                const { img, rank, url, title, name } = item;

                                                return (
                                                    <div className={styles.partItem} key={`breakthrough${index}`}>
                                                        <HonorItem
                                                            img={img}
                                                            rank={rank}
                                                            url={url}
                                                            title={title}
                                                            name={name}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                        </div>
                        <div className={styles.footer}>
                            <img
                                src="https://x0.ifengimg.com/ucms/2021_30/56F265240185C808090444A7505BA44598E38D99_size24_w2560_h139.png"
                                alt="页尾"
                                className={styles.normal}
                            />
                            <img
                                src="https://x0.ifengimg.com/ucms/2021_30/A85E31C096A1912D554ACF00784E8C2F2A1D165E_size8_w742_h30.png"
                                className={styles.text}
                            />
                        </div>
                        <div>
                            <Footer content={navData} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Layout);
